module.exports = __webpack_public_path__ + "img/corporal.72fc0337.jpg";